import { Document } from '@contentful/rich-text-types'
import { ICapability as IContentfulCapability } from 'marketing-site/@types/generated/contentful'
import { ISolution, transformSolution } from './ContentfulCapabilitySolution'
import { ITestimonial, transformTestimonial } from './ContentfulCapabilityTestimonial'
import { IFeatureCollection, transformFeatureCollection } from './ContentfulFeatureCollection'
import { ReactNode } from 'react'
import { transformMedia } from '../elements/ContentfulMedia'
import { isImage } from '../elements/ContentfulImage'
import { transformImageWithModalVideo } from 'marketing-site/src/mvp/transformers/elements/ContentfulImageWithModalVideo'

export interface ICapability {
  name: string
  media: ReactNode
  keyFeatures: IFeatureCollection
  secondaryFeatures?: IFeatureCollection
  testimonial: ITestimonial
  solutionsEyebrow?: string
  solutionsHeading: string
  solutionsSubheading?: Document
  solutions: ISolution[]
}

export function transformCapability(props: IContentfulCapability): ICapability {
  const { name, media, keyFeatures, secondaryFeatures, testimonial, solutions } = props.fields
  return {
    name,
    media: isImage(media) ? transformMedia(media) : transformImageWithModalVideo(media),
    keyFeatures: transformFeatureCollection(keyFeatures),
    secondaryFeatures: secondaryFeatures && transformFeatureCollection(secondaryFeatures),
    testimonial: transformTestimonial(testimonial),
    solutionsEyebrow: solutions.fields.eyebrow,
    solutionsHeading: solutions.fields.title,
    solutionsSubheading: solutions.fields.subhead,
    solutions: solutions.fields.items.map((solution) => transformSolution(solution)),
  }
}
